<div
  class="rect"
  [attr.data-color]="displayColor"
>
  @if (alarmEvent && !elemDef.hideAlarmMenu) {
    <motn-tile-alarm-badge
      [alarmEvent]="alarmEvent"
      [alarmMenuOptions]="alarmMenuOptions"
      (click)="showAlarmOptionsMenu()"
      (clickedAfterRender)="alarmMenuOptions = null"
    ></motn-tile-alarm-badge>
  }

  @if (displayIcon) {
    <div
      (click)="openTileMenu()"
      class="icon header-icon"
      [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
    ></div>
  }

  @if (tileMenuOpen) {
    <motn-popover-menu
      [menuTitle]="tileMenuTitle"
      [optionGroup]="displayedMenuOptions"
      [overlayPositions]="popoverPositions"
      [hoverColor]="tileMenuHoverColor"
      (clickedOutsideMenu$)="tileMenuOpen = false"
      (clickedOption$)="tileMenuOpen = false"
    ></motn-popover-menu>
  }

  @if (loading) {
    <div
      class="value"
    >
      <div
        class="display-value"
      >
        <motn-spinner></motn-spinner>
      </div>
    </div>
  }

  @if (!loading && tile && elemDef.showStateText) {
    <div
      class="value"
    >
      <div
        class="display-value"
        [class.stale-shown]="staleValue"
      >
        {{displayValue}} {{tile.getUnitsLabel()}}

        <div
          class="stale-value"
          [motnTooltip]="staleTooltip"
          [tooltipShowOnClick]="true"
          [tooltipDisabled]="!staleValue"
          tooltipPosition="bottom"
        >
          {{staleValue}}
        </div>
      </div>
    </div>
  }

  @if (!loading && tile && elemDef.showToggle && structure.Writable) {
    <div
      class="value"
    >
      <label
        [ngClass]="{
          'toggle': 1,
          'disabled': sendingValue !== null
        }"
        (click)="toggleValue($event)"
      >
        <input
          [(ngModel)]="rawValue"
          type="checkbox"
        >
        <span class="slider"></span>
      </label>
    </div>
  }

  <div class="bottom">
    @if (facetValues.length > 0) {
      <div class="facets">
        @for (val of facetValues; track $index) {
          @if (!$first) {<i class="fa-solid fa-circle-dot"></i>}
          <span>{{ val }}</span>
        }
      </div>
    }
    <div class="name">
      <span>{{displayName}}</span>
      @if (displayAlarmText) {
        <span class="alarm-text">
          <i class="fa-sharp fa-solid fa-circle-info"></i> {{ displayAlarmText }}
        </span>
      }
    </div>
  </div>
</div>

@if (_showSchedules) {
  <motn-schedules-viewer
    (clickedOutside$)="hideSchedules()"
    [tile]="tile"
  ></motn-schedules-viewer>
}
